import { Button, Dialog, DialogActions, DialogBody, DialogContent, DialogSurface, DialogTitle, DialogTrigger, Label, Textarea } from "@fluentui/react-components";
import { FormEvent, FunctionComponent } from "react";

export const FeedbackDialog: FunctionComponent<{ feedbackType: string, setFeedbackContent: (s: string) => void, handleSubmitFeedback: (event: FormEvent) => void, openFeedbackDialog: boolean, setOpenFeedbackDialog: (b: boolean) => void }> = ({ feedbackType, setFeedbackContent, handleSubmitFeedback, openFeedbackDialog, setOpenFeedbackDialog }) => {

    return (<Dialog
        open={openFeedbackDialog}
        onOpenChange={(event, data) => {
            setOpenFeedbackDialog(data.open);
        }}>
        <DialogSurface>
            <form onSubmit={handleSubmitFeedback}>
                <DialogBody>
                    <DialogTitle>Provide Feedback</DialogTitle>
                    <DialogContent>
                        <div className='dialog-content'>
                            <div className='feedback-icons'>
                                {feedbackType === 'positive' && <span className="feedback-icon material-symbols-rounded" >thumb_up</span>}
                                {feedbackType !== 'positive' && <span className="feedback-icon material-symbols-rounded" >thumb_down</span>}
                            </div>
                            <Label required htmlFor={"feedback-content"}>
                                Feedback
                            </Label>
                            <Textarea onChange={e => setFeedbackContent(e.target.value)} className='feedback-area' required id={"feedback-content"} size='large' />
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button type="submit" appearance="primary">Submit Feedback</Button>
                        <DialogTrigger disableButtonEnhancement>
                            <Button appearance="secondary">Cancel</Button>
                        </DialogTrigger>
                    </DialogActions>
                </DialogBody>
            </form>
        </DialogSurface>
    </Dialog>)
}